import React from "react";

const Navbar = () => {

        return(
    <nav className="bg-gray-950 p-4">
        <div className="container mx-auto flex justify-between items-center">
            <h1 className="text-white text-3xl font-bold">Reza</h1>
            <div >
                <a href="#about" className="text-gray-50 hover:text-white mx-4 transition duration-300">about</a>
                <a href="#project" className="text-gray-50 hover:text-white mx-4 transition duration-300">project</a>
                <a href="#contact" className="text-gray-50 hover:text-white mx-4 transition duration-300">contact</a>
            </div>
        </div>
    </nav>
        )
}

export default Navbar;